import { Box, Button, Dialog, Typography, useTheme } from '@mui/material'
import { useEffect, useState } from 'react';
import { font } from '../../styles/font';

export default function ConfirmationDialog({ open, handleClose, handleContinue, data, title, description, onKeyDown }) {
    const theme = useTheme();
    const [loading, setLoading] = useState(false);

    const [confirmData, setConfirmData] = useState(null);

    const handleCloseDialog = () => {
        handleClose();
    }

    useEffect(() => {
        if (data) {
            setConfirmData(data);
        }
    }, [data])

    // Determine button text color based on theme mode
    const getButtonTextColor = () => {
        return theme.palette.mode === 'light' ? '#ffffff' : '#000000';
    }

    return (
        <Dialog
            open={Boolean(open)}
            onClose={handleCloseDialog}
            fullWidth
            maxWidth="xs"
            sx={{
                // '& .MuiDialog-paper': {
                //     width: '100%',
                //     maxWidth: '400px',
                //     // height: '60vh'
                // }
            }}
            onKeyDown={onKeyDown}
        >
            <Box className="flex flex-col gap-0  h-full w-full">
                <Box className="flex flex-col gap-4 px-4 py-2  w-full">
                    <Typography 
                        fontSize={font.size.fs_4} 
                        color={theme.palette.primary.main}  // Primary color for header
                    >
                        {title ? title : "Confirmation"}
                    </Typography>
                </Box>

                <Box className="flex flex-col gap-0.5 px-4 py-2   flex-1 w-full">
                    <Typography 
                        fontSize={font.size.fs_5} 
                        color={theme.palette.text.secondary}
                    >
                        {description ? description : "Are you sure you want to continue?"}
                    </Typography>
                    {confirmData && (
                        <Typography 
                            fontSize={font.size.fs_5} 
                            color={theme.palette.text.primary}
                        >
                            {JSON.stringify(confirmData)}
                        </Typography>
                    )}
                </Box>

                <Box className="flex justify-end gap-4 px-4 py-2  w-full">
                    <Button 
                        onClick={handleCloseDialog}
                        sx={{
                            backgroundColor: theme.palette.error.main,
                            color: getButtonTextColor(),  // White in light, black in dark
                            '&:hover': {
                                backgroundColor: theme.palette.error.main,
                            }
                        }}
                    >
                        Cancel
                    </Button>
                    <Button 
                        onClick={handleContinue}
                        sx={{
                            backgroundColor: theme.palette.primary.main,
                            color: getButtonTextColor(),  // White in light, black in dark
                            '&:hover': {
                                backgroundColor: theme.palette.primary.main,
                            }
                        }}
                    >
                        Confirm
                    </Button>
                </Box>
            </Box>

        </Dialog>
    )
}